ACC.subscriptionItems = {

    init() {
        this.forceHeights();
        this.insertPaddingIfNoSale();
    },

    forceHeights() {
        const blocks = document.querySelectorAll('.c-subscription__price-detail');
        let minHeight = 0;

        blocks.forEach((el) => {
            if (el.offsetHeight > minHeight) {
                minHeight = el.offsetHeight;
            }
        });

        blocks.forEach((el) => {
            el.classList.add('js-setMinHeight');
            el.style.minHeight = `${minHeight}px`;
        });
    },

    insertPaddingIfNoSale() {
        const priceBlocks = document.querySelectorAll('.c-subscription__price-block');

        const paddingNeeded = this.isPaddingNeeded(priceBlocks);

        if (paddingNeeded) {
            priceBlocks.forEach((el) => {
                const price = el.querySelector('.c-subscription__discount-price');
                if (!price) {
                    el.classList.add('hasNoDiscount');
                }
            });
        }
    },

    isPaddingNeeded(elements) {
        const discounts = [];
        elements.forEach((el) => discounts.push(el.querySelector('.c-subscription__discount-price')));
        return discounts.some((el) => el);
    },
};
